module.exports = __webpack_public_path__ + "img/palm-pool-2.7a878dd6.jpg";